import { api } from '../api/api';

/** A planning area on the demo server, as GET /api/demo-tenants lists it. */
export interface DemoArea {
  uuid: string;
  name: string;
  /** The planning area the user is working in; it cannot be reset from here. */
  current: boolean;
}

export interface DemoOverview {
  areas: DemoArea[];
  templates: DemoArea[];
}

/** Rows per table that an action deleted or copied. */
export interface DemoResetResult {
  rows: Record<string, number>;
}

/** Only on the Prod demo server; elsewhere the backend answers 404. */
export async function fetchDemoOverview(): Promise<DemoOverview> {
  const response = await api.get<DemoOverview>('/api/demo-tenants');
  return response.data;
}

export async function emptyDemoArea(uuid: string, confirmName: string): Promise<DemoResetResult> {
  const response = await api.post<DemoResetResult>(`/api/demo-tenants/${uuid}/empty`, { confirmName });
  return response.data;
}

export async function fillDemoArea(uuid: string, templateUuid: string, confirmName: string): Promise<DemoResetResult> {
  const response = await api.post<DemoResetResult>(`/api/demo-tenants/${uuid}/fill`, { confirmName, templateUuid });
  return response.data;
}
